module.exports = __webpack_public_path__ + "img/sand-decal-14.9268737a.png";